(ns frontend.ui.component.lp-portal.multiselect.view
  (:require
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.multiselect.style :as style]
   [reagent.core :as r]
   [clojure.string :as string]
   [schema.core :as s]))

(s/defschema Options
  [{:id       (s/cond-pre s/Int s/Str s/Keyword)
    :label    s/Str
    :category s/Str}])

(defn multiselect
  [props]
  (let [is-open (r/atom false)
        filter-query (r/atom "")
        on-outside-click (fn []
                           (swap! is-open (fn [] false)))
        selected-option-index (r/atom 0)]
    (r/create-class
     {:display-name
      "multiselect"
      :component-did-mount
      (fn []
        (.addEventListener js/document.body "click" on-outside-click))
      :component-will-unmount
      (fn []
        (.removeEventListener js/document.body "click" on-outside-click))
      :reagent-render
      (fn [{:keys [options selected-ids on-select on-deselect placeholder z-index] :as props}]
        (s/validate Options options)
        (let [options-by-id (->> options
                                 (mapcat
                                  (fn [option]
                                    [(:id option) option]))
                                 (apply hash-map))
              filtered-options (->> options
                                    (filter
                                     (fn [option]
                                       (string/includes?
                                        (-> option
                                            :label
                                            string/lower-case)
                                        (-> @filter-query
                                            (string/lower-case)
                                            (string/trim)))))
                                    (filter
                                     (fn [option]
                                       (not (contains? selected-ids (:id option))))))]
          [:div
           {:class (<class style/container)
            :style (when @is-open {:z-index (or z-index 1)})}
           [:div
            {:class (<class style/trigger)}
            (when (not-empty selected-ids)
              [:div
               {:class (<class style/selected-options)}
               (->> selected-ids
                    (map (fn [id] (get options-by-id id)))
                    (sort-by :label)
                    (map
                     (fn [selected-option]
                       [:div
                        {:key   (:id selected-option)
                         :class (<class style/selected-option)}
                        [:div
                         {:class (<class style/selected-option-text)}
                         (:label selected-option)]
                        [:div
                         {:class    (<class style/deselect-button)
                          :on-click (fn []
                                      (when
                                        on-deselect
                                        (on-deselect (:id selected-option))))}
                         [:i.fal.fa-times
                          {:class (<class style/deselect-button-icon)}]]]))
                    (doall))])
            [:div
             {:class    (<class style/input-container)
              :on-click (let [is-open-value @is-open]
                          (fn [event]
                            (.-stopPropagation event)
                            (swap! is-open (fn [] (not is-open-value)))))}
             [:input
              {:class       (<class style/input)
               :value       @filter-query
               :placeholder placeholder
               :on-key-down (fn [event]
                              (case (-> event
                                        .-key)
                                "Escape" (do
                                           (swap! is-open (fn [] false))
                                           (swap! filter-query (fn [] "")))
                                "Enter" (do
                                          (swap! filter-query (fn [] ""))
                                          (->> @selected-option-index
                                               (nth filtered-options)
                                               :id
                                               (on-select)
                                               (when on-select))
                                          (swap! selected-option-index (fn [] 0))
                                          (swap! is-open (fn [] false)))
                                "ArrowUp" (swap! selected-option-index (fn []
                                                                         (-> @selected-option-index
                                                                             (dec)
                                                                             (max 0))))
                                "ArrowDown" (if @is-open
                                              (swap! selected-option-index
                                                (fn []
                                                  (-> @selected-option-index
                                                      (inc)
                                                      (min (-> options
                                                               (count)
                                                               (dec))))))
                                              (swap! is-open (fn [] true)))
                                (when-not @is-open (swap! is-open (fn [] true)))))
               :on-change   (fn [event]
                              (swap!
                                filter-query
                                (fn []
                                  (->> event
                                       .-target
                                       .-value))))}]
             [:i.fas.fa-caret-down
              {:class (<class style/caret)}]]]

           (when @is-open
             [:div
              {:class (<class style/content-container)}
              (->> filtered-options
                   (map-indexed
                    (fn [index option]
                      (assoc option :index index)))
                   (group-by :category)
                   (map
                    (fn [grouped-options]
                      (let [category (first grouped-options)
                            category-options (last grouped-options)]
                        [:<>
                         {:key category}
                         [:div
                          {:class (<class style/category-title)}
                          category]
                         (->> category-options
                              (map
                               (fn [option]
                                 [:div
                                  {:key      (:id option)
                                   :class    (<class (partial style/option
                                                              (= @selected-option-index
                                                                 (:index option))))
                                   :on-click (fn []
                                               (swap! filter-query (fn [] ""))
                                               (swap! selected-option-index (fn [] 0))
                                               (when on-select (on-select (:id option))))}
                                  (:label option)]))
                              (doall))])))
                   (doall))])]))})
  ))
